// @ts-nocheck
import {loadAbort} from "./loadAbort.utility";
import apiInstance from "./public.instance";

const setHeaders = additionalHeaders => {
  return {
    ...additionalHeaders,
  };
};

const publicRequest = {
  get: async (url, _body, additionalHeaders) => {
    const controller = loadAbort();
    const config = {
      headers: setHeaders(additionalHeaders),
      signal: controller.signal,
    };
    const response = await apiInstance.get(url, config);
    const {status, data} = response;
    return {data, status};
  },

  put: async (url, body, additionalHeaders) => {
    const config = {
      headers: setHeaders(additionalHeaders),
    };

    // send headers and request to URL
    const response = await apiInstance({
      method: "put",
      url,
      data: body,
      ...config,
    });
    const {data, status} = response;
    return {data, status};
  },

  patch: async (url, body, additionalHeaders) => {
    const config = {
      headers: setHeaders(additionalHeaders),
    };

    // send headers and request to URL
    const response = await apiInstance({
      method: "patch",
      url,
      data: body,
      ...config,
    });
    const {data, status} = response;
    return {data, status};
  },

  post: async (url, body, additionalHeaders) => {
    const config = {
      headers: setHeaders(additionalHeaders),
    };

    // send headers and request to URL
    const response = await apiInstance({
      method: "post",
      url,
      data: body,
      ...config,
    });
    const {data, status} = response;
    return {data, status};
  },

  delete: async (url, body, additionalHeaders) => {
    const config = {
      headers: setHeaders(additionalHeaders),
    };

    // send headers and request to URL
    const response = await apiInstance({
      method: "delete",
      url,
      data: body,
      ...config,
    });
    const {data, status} = response;
    return {data, status};
  },
};

export default publicRequest;
